import moment from 'moment';

export const calendarDate = date => moment(date).format('MM/DD/YYYY HH:mm')

export const prettyDateTime = (date) => moment(date).format('DD/MM/YYYY HH:mm');
export const prettyTime = (date) => moment(date).format('HH:mm');

export const prettyDate = (date) => moment(date).format('DD/MM/YYYY');

export const serverDate = (date) => !!date ? moment(date).format('YYYY-MM-DD') : null;

export const formatDateDouble = (date) => `${date.getFullYear()}-${('0' + date.getMonth()+1).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
//input: formatted (calendar) js date string => output: YYYY-MM-DD

export const formattedDate = (date) => {
  if(!date) return null;
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const formattedTime = (time) => {
   return moment(time, "HH:mm:ss").format("HH:mm");
}


export const fancyTimeFormat = (duration) => {
    const hours = ~~(duration / 3600);
    const minutes = ~~((duration % 3600) / 60);
    const seconds = ~~(duration % 60);

    const getPlural = (value) => {
        return value > 1 ? 's' : '';  
    }

    let fancyFormat = hours > 0 ? `${hours} hora${getPlural(hours)}` : ``;
    fancyFormat += minutes > 0 ? ` ${minutes} minuto${getPlural(minutes)}` : ``;
    fancyFormat += seconds > 0 ? ` ${seconds} segundo${getPlural(seconds)}` : ``;

    return fancyFormat;
}

export const changeToUSDate = (date) => {
    const array= date.split("-");

   return `${array[1]}/${array[2]}/${array[0]}`}
//input: YYYY-MM-DD => output: MM-DD-YYYY

export const changeToUSDate2 = (date) => {
    const array= date.split("/");

   return `${array[2]}-${array[1]}-${array[0]}`}
//input: YYYY-MM-DD => output: MM-DD-YYYY

export const changeToBRDate = (date) => {
    const array= date.split("-");

   return `${array[2]}/${array[1]}/${array[0]}`}
//input: YYYY-MM-DD => output: DD-MM-YYYY

export const setFutureDate = (initialDate, years) => {
    const year = initialDate.getFullYear();
    const month = initialDate.getMonth();
    const day = initialDate.getDate();
    const future = new Date(year + years, month, day);
    return future;
}
//input: new Date(), x years from this date = > output: creates a date in the future with X years from first inputed date.

export const getDaysInMonth = (month, year) => 
(new Array(31)).fill('').map((v,i)=>new Date(year,month-1,i+1)).filter(v=>v.getMonth()===month-1)
//input: month, year => output: which days the inputted month has.



export const getDaysInMonthFormatted=(month, year)=>{
    const oldDates = getDaysInMonth(month, year)
    const newDates=oldDates.map(oldDate=> formattedDate(oldDate))
    return newDates
}
//input: month, year => output: YYYY-MM-DD

export const isDatePreviousThanToday = (date) => {
   return moment(new Date()).isAfter(date, 'day')
}
